/**
 * Determines whether an element is expandable and whether its state allows it to expand.
 *
 * @param {HTMLElement} element
 * @returns {boolean}
 */
export function canExpand(element: HTMLElement): boolean {
    return (
        'expanded' in element && !element.expanded && isControlEnabled(element)
    );
}

/**
 * Determines if a form control and its child input/select element are both enabled (not disabled or readonly).
 *
 * @param {HTMLElement} element
 * @returns {boolean}
 */
function isControlEnabled(element: HTMLElement): boolean {
    const child = element.localName === 'ui-dropdown' ? 'select' : 'input';
    return isEnabled(element) && isEnabled(element.querySelector(child));
}

/**
 * Determines whether an element is enabled, meaning not disabled or readonly.
 * Missing elements are treated as enabled, since there is no disabled state to block interaction.
 *
 * @param {HTMLElement | null | undefined} element
 * @returns {boolean}
 */
function isEnabled(element: HTMLElement | null): boolean {
    if (!element) {
        return true;
    }
    return !(
        element.hasAttribute('disabled') || element.hasAttribute('readonly')
    );
}
